import React from 'react';
import uuidv4 from 'uuid/v4';
import { connect } from 'react-redux';
import { Container, Message } from 'semantic-ui-react';

import '../styles/FlashMessageList.css';

const FlashMessageList = props => {
  const SUCCESS = 'success';
  const WARNING = 'warning';
  const ERROR = 'error';

  const { messages } = props;

  if (!messages || (messages && messages.length === 0)) {
    return null;
  }

  return (
    <Container className="FlashMessageList">
      {messages.map(message => (
        <Message
          compact
          key={uuidv4()}
          error={message.type === ERROR}
          success={message.type === SUCCESS}
          warning={message.type === WARNING}
          content={message.text}
        />
      ))}
    </Container>
  );
};

const mapStateToProps = state => ({
  messages: state.notifications.messages
});

export default connect(mapStateToProps)(FlashMessageList);



// WEBPACK FOOTER //
// ./src/containers/FlashMessageList.js